import { render, staticRenderFns } from "./PFCustomerAddress.vue?vue&type=template&id=a884e44a"
import script from "./PFCustomerAddress.vue?vue&type=script&lang=js"
export * from "./PFCustomerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports